export const dateFormatter = new Intl.DateTimeFormat("de-DE", {
  day: "2-digit",
  month: "2-digit",
});

export const CHART_TYPES = ["line", "bar"];

// Bright accent colors for per-day breakdown (no green to avoid conflict with cumulative)
export const DAY_COLORS = [
  { border: "rgba(239, 68, 68, 1)", bg: "rgba(239, 68, 68, 0.2)" },
  { border: "rgba(168, 85, 247, 1)", bg: "rgba(168, 85, 247, 0.2)" },
  { border: "rgba(249, 115, 22, 1)", bg: "rgba(249, 115, 22, 0.2)" },
  { border: "rgba(236, 72, 153, 1)", bg: "rgba(236, 72, 153, 0.2)" },
  { border: "rgba(234, 179, 8, 1)", bg: "rgba(234, 179, 8, 0.2)" },
];

// Two distinct color families for comparison mode
export const COMPARISON_COLORS = {
  primary: {
    daily: {
      border: "rgba(37, 99, 235, 1)",
      background: "rgba(37, 99, 235, 0.15)",
    },
    cumulative: {
      border: "rgba(5, 150, 105, 1)",
      background: "rgba(5, 150, 105, 0.08)",
    },
  },
  compare: {
    daily: {
      border: "rgba(220, 38, 38, 1)",
      background: "rgba(220, 38, 38, 0.15)",
    },
    cumulative: {
      border: "rgba(217, 119, 6, 1)",
      background: "rgba(217, 119, 6, 0.08)",
    },
  },
};
